import React from "react";
import { socials } from "../mock";
import { track } from "../analytics";

const ICONS = {
  facebook: (
    <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5 3.66 9.15 8.44 9.94v-7.03H7.9v-2.91h2.54V9.85c0-2.51 1.49-3.9 3.77-3.9 1.09 0 2.23.2 2.23.2v2.46h-1.26c-1.24 0-1.63.78-1.63 1.57v1.88h2.78l-.45 2.91h-2.33V22c4.78-.79 8.45-4.94 8.45-9.94z" />
  ),
  instagram: (
    <>
      <defs>
        <linearGradient id="ig-grad" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0%" stopColor="#FEDA75" />
          <stop offset="28%" stopColor="#FA7E1E" />
          <stop offset="56%" stopColor="#D62976" />
          <stop offset="80%" stopColor="#962FBF" />
          <stop offset="100%" stopColor="#4F5BD5" />
        </linearGradient>
      </defs>
      <path
        fill="url(#ig-grad)"
        d="M12 2c2.72 0 3.06.01 4.12.06 1.07.05 1.79.22 2.43.47.66.25 1.22.6 1.77 1.15.55.55.9 1.11 1.15 1.77.25.64.42 1.36.47 2.43.05 1.06.06 1.4.06 4.12s-.01 3.06-.06 4.12c-.05 1.07-.22 1.79-.47 2.43-.25.66-.6 1.22-1.15 1.77-.55.55-1.11.9-1.77 1.15-.64.25-1.36.42-2.43.47-1.06.05-1.4.06-4.12.06s-3.06-.01-4.12-.06c-1.07-.05-1.79-.22-2.43-.47a4.9 4.9 0 0 1-1.77-1.15 4.9 4.9 0 0 1-1.15-1.77c-.25-.64-.42-1.36-.47-2.43C2.01 15.06 2 14.72 2 12s.01-3.06.06-4.12c.05-1.07.22-1.79.47-2.43.25-.66.6-1.22 1.15-1.77.55-.55 1.11-.9 1.77-1.15.64-.25 1.36-.42 2.43-.47C8.94 2.01 9.28 2 12 2zm0 1.8c-2.67 0-2.99.01-4.04.06-.82.04-1.27.17-1.56.29-.4.15-.68.34-.98.64-.3.3-.49.58-.64.98-.12.29-.25.74-.29 1.56-.05 1.05-.06 1.37-.06 4.04s.01 2.99.06 4.04c.04.82.17 1.27.29 1.56.15.4.34.68.64.98.3.3.58.49.98.64.29.12.74.25 1.56.29 1.05.05 1.37.06 4.04.06s2.99-.01 4.04-.06c.82-.04 1.27-.17 1.56-.29.4-.15.68-.34.98-.64.3-.3.49-.58.64-.98.12-.29.25-.74.29-1.56.05-1.05.06-1.37.06-4.04s-.01-2.99-.06-4.04c-.04-.82-.17-1.27-.29-1.56a2.6 2.6 0 0 0-.64-.98 2.6 2.6 0 0 0-.98-.64c-.29-.12-.74-.25-1.56-.29-1.05-.05-1.37-.06-4.04-.06zm0 3.06a5.14 5.14 0 1 1 0 10.28 5.14 5.14 0 0 1 0-10.28zm0 1.8a3.34 3.34 0 1 0 0 6.68 3.34 3.34 0 0 0 0-6.68zm6.54-2.2a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0z"
      />
    </>
  ),
  x: (
    <path d="M17.53 3h3.2l-6.99 7.99L22 21h-6.3l-4.28-5.6L6.5 21H3.3l7.3-8.35L2.5 3h6.44l4 5.26L17.53 3zm-1.13 16.06h1.77L7.02 4.85H5.12l11.28 14.21z" />
  ),
  tiktok: (
    <>
      <path
        fill="#25F4EE"
        d="M15.1 5.82A4.28 4.28 0 0 1 14.04 3h-2.4v12.4a2.6 2.6 0 1 1-1.86-2.5V9.7a5.71 5.71 0 1 0 4.96 5.66V8.9a7.34 7.34 0 0 0 4.3 1.38V7.18a4.29 4.29 0 0 1-3.94-1.36z"
      />
      <path
        fill="#FE2C55"
        d="M17.5 6.62A4.28 4.28 0 0 1 16.44 3h-2.4v12.4a2.6 2.6 0 1 1-1.86-2.5V9.7a5.71 5.71 0 1 0 4.96 5.66V8.9a7.34 7.34 0 0 0 4.3 1.38V7.98a4.29 4.29 0 0 1-3.94-1.36z"
      />
      <path
        fill="currentColor"
        d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.1v12.4a2.6 2.6 0 1 1-1.86-2.5V9.7a5.71 5.71 0 1 0 4.96 5.66V8.9a7.34 7.34 0 0 0 4.3 1.38V7.18a4.29 4.29 0 0 1-3.24-1.36z"
      />
    </>
  ),
};

export const SocialLinks = ({ className = "" }) => {
  const live = socials.filter((s) => s.url);
  if (!live.length) return null;

  return (
    <ul className={`inz-social ${className}`.trim()} data-testid="social-links">
      {live.map((s) => (
        <li key={s.id}>
          <a
            className={`s-${s.id}`}
            href={s.url}
            target="_blank"
            rel="noopener noreferrer me"
            aria-label={`InZoRAH on ${s.label}`}
            title={s.label}
            data-testid={`social-${s.id}`}
            onClick={() => track("click_social", { label: s.label })}
          >
            <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
              {ICONS[s.id]}
            </svg>
          </a>
        </li>
      ))}
    </ul>
  );
};

export default SocialLinks;
